import { motion } from 'framer-motion'

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15, delayChildren: 0.1 },
  },
}

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
}

const risks = [
  'Acusações de erro médico e falhas em prontuários destroem reputações que levaram décadas para serem construídas.',
  'Comunicação por WhatsApp com pacientes ou orientações informais tornam você juridicamente vulnerável a cada nova mensagem.',
  'Contratos mal formulados em clínicas resultam em perdas financeiras silenciosas e responsabilidade solidária injusta.',
]

export default function Problem() {
  return (
    <section className="relative w-full bg-surface-section-alt py-16 md:py-24 overflow-hidden flex justify-center items-center">
      <div className="relative max-w-[900px] mx-auto px-6 w-full flex flex-col items-center text-center z-10">

        <motion.span
          className="text-[11px] font-bold uppercase tracking-widest text-text-muted mb-6"
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.5 }}
        >
          O problema que ninguém fala
        </motion.span>

        <motion.h2
          className="text-[26px] sm:text-[32px] md:text-[44px] font-extrabold tracking-tight leading-[1.1] text-text-primary mb-10 md:mb-16 max-w-[800px]"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          Você aprendeu a salvar vidas.<br />
          Ninguém te ensinou a se <span className="text-accent-primary">defender.</span>
        </motion.h2>

        <motion.div
          className="flex flex-col md:flex-row gap-8 md:gap-8 w-full mt-4 md:mt-16 text-left"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-50px' }}
        >
          {risks.map((text, index) => (
            <motion.div key={index} variants={itemVariants} className="flex-1 flex flex-col items-start">
              <div className="flex items-center gap-4 mb-4">
                <span className="w-1 h-6 bg-accent-primary rounded-full" />
                <span className="font-mono text-[11px] font-bold tracking-wider text-accent-primary">
                  {String(index + 1).padStart(2, '0')}
                </span>
              </div>
              <p className="text-[16px] leading-relaxed text-text-secondary">{text}</p>
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  )
}
